/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// formik components
import { ErrorMessage, Field, FieldAttributes } from "formik";

// Material Dashboard 2 PRO React TS components
import MDBox from "dashboard-template/components/MDBox";
import MDTypography from "dashboard-template/components/MDTypography";
import MDInput from "dashboard-template/components/MDInput";
import { forwardRef } from "react";
import { TextFieldProps } from "@mui/material";

/**
 * Props for FormField component.
 * @typedef {Object} FormInputProps
 * @property {string} [label] - Field label text
 * @property {string} name - Formik field name for binding
 * @property {boolean} [error] - Error state flag
 * @property {boolean} [success] - Success state flag
 * @property {boolean} [readOnly] - Read-only mode flag
 */
export type FormInputProps = FieldAttributes<TextFieldProps> & {
  label?: string;
  name: string;
  error?: boolean;
  success?: boolean;
  readOnly?: boolean;
};

/**
 * Formik-integrated text input field with error display.
 * 
 * Features:
 * - Formik Field integration
 * - Automatic error message display
 * - Standard variant styling
 * - Full width responsive
 * - Read-only mode support
 * - Material Dashboard styling
 * 
 * @param label - Input field label
 * @param name - Formik field name
 * @param readOnly - Disables input when true
 * @param rest - Additional TextField props
 * @returns Form input field with Formik binding
 */
const FormField = forwardRef(({ label, name, readOnly, ...rest }: FormInputProps, ref) => {
  return (
    <MDBox mb={1.5}>
      <Field
        className={`formik-input ${rest.className}`}
        name={name}
        as={MDInput}
        disabled={readOnly}
        label={label}
        fullWidth
        ref={ref}
        {...rest}
        variant="standard"
      />
      <MDBox mt={0.75}>
        <MDTypography className="cy-error-yup formField-error-label" component="div" variant="caption" color="error" fontWeight="regular">
          {(<ErrorMessage name={name} />) as any}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
});

export default FormField;
